import { createFileRoute } from '@tanstack/react-router';
import { PackEditor } from '@/features/accountant/pack-editor';

export const Route = createFileRoute('/reports/management/new')({
  component: () => <PackEditor pack={null} />,
});
